import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullTeam from "../fragments/fullTeamV4"

const query = gql`
  query Teams($tenantId: String!, $state: TeamState, $enabled: Boolean) {
    teams(tenantId: $tenantId, state: $state) {
      limit
      count
      offset
      results {
        ...fullTeam
        users(enabled: $enabled, totalOnly: true) {
          total
        }
        managers(enabled: $enabled, totalOnly: true) {
          total
        }
      }
    }
  }
  ${fullTeam}
`

export const teamsKey = getQueryNames(query)[0]

export default query
